import React from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pTradeBuyComplete.css';

const mockOrderData = {
  orderId: '9573006193730401',
  merchant: {
    name: 'Daniel Abraham',
    initial: 'D',
    verified: true,
    fullName: 'DANIEL ABRAHAM'
  },
  orderDetails: {
    quantity: '10.00',
    crypto: 'USDT',
    amountFiat: '615.00',
    currency: 'PHP',
    price: '61.5',
    priceUnit: 'PHP/USDT'
  },
  paymentMethod: {
    bankName: 'GCASH',
    accountName: 'Myrna Luz Tan',
    bank: 'GCASH',
    accountNumber: '09178389080',
    icon: 'G'
  }
};

const P2pTradeBuyComplete: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleChat = () => {
    console.log('Opening chat...');
  };

  const handleCopyOrderId = () => {
    navigator.clipboard.writeText(mockOrderData.orderId);
  };

  const handleCopyAccountName = () => {
    navigator.clipboard.writeText(mockOrderData.paymentMethod.accountName);
  };

  const handleCopyAccountNumber = () => {
    navigator.clipboard.writeText(mockOrderData.paymentMethod.accountNumber);
  };

  const handleBackToTrading = () => {
    navigate('/p2p-buy-list');
  };

  return (
    <div className="complete-container">
      <header className="complete-header">
        <button className="complete-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="complete-title">Buy USDT</h1>

        <button className="complete-chat-button" onClick={handleChat} aria-label="Chat">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17 8.5C17 12.366 13.866 15.5 10 15.5C8.95 15.5 7.951 15.28 7.049 14.888L3 16L4.112 11.951C3.72 11.049 3.5 10.05 3.5 9C3.5 5.134 6.634 2 10.5 2C14.366 2 17.5 5.134 17.5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <div className="complete-chat-badge">3</div>
        </button>
      </header>

      <div className="complete-content">
        <div className="complete-merchant-card">
          <div className="complete-merchant-avatar">
            {mockOrderData.merchant.initial}
          </div>
          
          <div className="complete-merchant-info">
            <div className="complete-merchant-name">
              {mockOrderData.merchant.name}
              {mockOrderData.merchant.verified && (
                <svg className="complete-verified-badge" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 0L11.5 6.5L18 8L11.5 9.5L10 16L8.5 9.5L2 8L8.5 6.5L10 0Z" fill="#22c35d"/>
                </svg>
              )}
            </div>
            <div className="complete-merchant-label">Merchant</div>
          </div>
        </div>

        <div className="complete-success-card">
          <div className="complete-success-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10L8 14L16 6" stroke="#22c35d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className="complete-success-content">
            <h2 className="complete-success-heading">Trade Completed</h2>
            <p className="complete-success-subtitle">Successfully Concluded</p>
          </div>

          <p className="complete-success-description">
            This trade has been successfully concluded
          </p>
        </div>

        <div className="complete-order-id-card">
          <div className="complete-order-id-label">ID</div>
          <div className="complete-order-id-value">{mockOrderData.orderId}</div>
          <button 
            className="complete-copy-button" 
            onClick={handleCopyOrderId}
            aria-label="Copy order ID"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="complete-details-card">
          <div className="complete-detail-row">
            <span className="complete-detail-label">Quantity</span>
            <div className="complete-detail-value-group">
              <span className="complete-detail-amount">{mockOrderData.orderDetails.quantity}</span>
              <span className="complete-detail-crypto">{mockOrderData.orderDetails.crypto}</span>
            </div>
          </div>

          <div className="complete-divider" />

          <div className="complete-detail-row">
            <span className="complete-detail-label">Amount (Fiat)</span>
            <div className="complete-detail-value-group">
              <span className="complete-detail-amount">{mockOrderData.orderDetails.amountFiat}</span>
              <span className="complete-detail-currency">{mockOrderData.orderDetails.currency}</span>
            </div>
          </div>

          <div className="complete-divider" />

          <div className="complete-detail-row">
            <span className="complete-detail-label">Price</span>
            <div className="complete-detail-value-group">
              <span className="complete-detail-amount">{mockOrderData.orderDetails.price}</span>
              <span className="complete-detail-unit">{mockOrderData.orderDetails.priceUnit}</span>
            </div>
          </div>
        </div>

        <div className="complete-payment-card">
          <div className="complete-payment-merchant">
            <span className="complete-payment-label">Merchant Name</span>
            <span className="complete-payment-value">{mockOrderData.merchant.fullName}</span>
          </div>

          <div className="complete-payment-method-box">
            <div className="complete-bank-header">
              <div className="complete-bank-icon">
                {mockOrderData.paymentMethod.icon}
              </div>
              <span className="complete-bank-name">{mockOrderData.paymentMethod.bankName}</span>
              <div className="complete-bank-badge" />
            </div>

            <div className="complete-payment-info-row">
              <span className="complete-payment-info-label">Account Name</span>
              <span className="complete-payment-info-value">{mockOrderData.paymentMethod.accountName}</span>
              <button 
                className="complete-copy-icon-button" 
                onClick={handleCopyAccountName}
                aria-label="Copy account name"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>

            <div className="complete-payment-info-row">
              <span className="complete-payment-info-label">Bank</span>
              <span className="complete-payment-info-value">{mockOrderData.paymentMethod.bank}</span>
            </div>

            <div className="complete-payment-info-row">
              <span className="complete-payment-info-label">Account Number</span>
              <span className="complete-payment-info-value complete-account-number">{mockOrderData.paymentMethod.accountNumber}</span>
              <button 
                className="complete-copy-icon-button" 
                onClick={handleCopyAccountNumber}
                aria-label="Copy account number"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="complete-action-bar">
        <button className="complete-primary-button" onClick={handleBackToTrading}>
          Back to P2P Trading
        </button>
      </div>
    </div>
  );
};

export default P2pTradeBuyComplete;